<template>
  <div class="about-me-profile">
    <h3>{{title}}</h3>
    <p v-for="item in items"><span class="category"> {{item.category}}</span> <span class="value"> {{item.value}} </span></p>
  </div>
</template>

<script>

export default {
  name: 'ProfileCell',
  props: ['title', 'items']
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

h3 {
  color: pink;
}

div.about-me-profile span {
  font-size: 16px;
  text-align: left;
  /* background-color: orange; */
  display: inline-block;
  /* これがないと微妙にずれた。 */
  vertical-align: top;
}

div.about-me-profile span.category {
  width: 150px;

  /* height: 30px;
  line-height: 30px; */
}

div.about-me-profile span.value {
  width: 200px;
  color: darkGray;


  /* height: 30px;
  line-height: 30px; */
}


</style>



// WEBPACK FOOTER //
// src/components/ProfileCell.vue